import { type FC } from 'react';

import { useTrackActivePinChanged } from './internal/hooks/useTrackActivePinChanged';
import { useTrackClustersChanged } from './internal/hooks/useTrackClustersChanged';

export const MapActivePinUpdater: FC = () => {
  // Изменился активный кластер
  useTrackActivePinChanged();

  // Произошел перезапрос кластеров, нужно не потерять активный пин
  useTrackClustersChanged();

  return null;
};
